import request from '../utils/request';

export function getVoucherList(param) {
    return request({
        url: '/admin/voucher/getVoucherList',
        method: 'GET',
        params: param
    })
}
export function getVoucherDetail(id){
    return request({
        url: `/admin/voucher/getVoucherById?id=${id}`,
        method: 'GET'
    })
}
export function updateVoucherList(data){
    return request({
        url: '/admin/voucher/updateVoucher',
        method: 'PUT',
        data
    })
}
export function createVoucherList(data){
    return request({
        url: '/admin/voucher/createVoucher',
        method: 'POST',
        data
    })
}
export function deleteVoucher(data){
    return request({
        url: '/admin/voucher/deleteVoucher',
        method: 'Delete',
        data
    })
}
export function getVoucherTime(params){
    return request({
        url: `/admin/operatingHour/getOperatingHourList`,
        method: 'GET',
        params
    })
}
export function createVoucherTime(data){
    return request({
        url: '/admin/operatingHour/createOperatingHour',
        method: 'POST',
        data
    })
}
export function updateVoucherTime(data){
    return request({
        url: '/admin/operatingHour/updateOperatingHour',
        method: 'PUT',
        data
    })
}
export function deleteVoucherTime(data){
    return request({
        url: '/admin/operatingHour/deleteOperatingHour',
        method: 'Delete',
        data
    })
}

export function getVoucherUser(param) {
    return request({
        url: '/admin/voucher/getVoucherUserList',
        method: 'GET',
        params: param
    })
}

export function getCouponUser(param){
    return request({
        url:'/admin/voucher/getUserVoucherList',
        method:'GET',
        params:param
    })
}

// 获取启用的优惠券列表
export function getVoucherIsMiniAppVisible(){
    return request({
        url:'/voucher/getVoucherIsMiniAppVisible',
        method:'GET'
    })
}

export function giveUserVoucher(data){
    return request({
        url: '/admin/voucher/giveUserVoucher',
        method: 'POST',
        data
    })
}

export function revocationUserVoucher(data){
    return request({
        url: '/admin/voucher/revocationUserVoucher',
        method: 'Delete',
        data
    })
}

export function getVoucherLog(params){
    return request({
        url:'/admin/voucher/getVoucherLog',
        method:'GET',
        params
    })
}